import React from 'react';

export default function Xtracky() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='url(#paint0_linear_5201_6667)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M21.297 7H25.3283V10.2595L10.5157 25.1207H6V22.1677L12.283 16.2189L6 10.0013V7H10.2813L15.9064 12.6637L21.297 7ZM17.3123 21.1513L20.6983 17.5471L26 22.2808V25.266H21.6092L17.3123 21.1513Z'
        fill='url(#paint1_linear_5201_6667)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5201_6667'
          x1='16'
          y1='0'
          x2='16'
          y2='32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#2B3238' />
          <stop offset='1' stop-color='#202D39' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5201_6667'
          x1='16'
          y1='7'
          x2='16'
          y2='25.266'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#00F9FF' />
          <stop offset='1' stop-color='#00ACED' />
        </linearGradient>
      </defs>
    </svg>
  );
}
